<template>
    <!-- Current Image Caption-->
    <transition name="fade">
        <div
            v-if="preTitle || title"
            class="bg-black-700 -mt-2 px-8 py-2 uppercase text-sm text-center transition-all duration-200"
        >
            <span
                v-if="preTitle"
                class="text-gold-500 font-bold mr-1">{{ preTitle }}</span>
            <br v-if="preTitle && title" />
            <span
                v-if="title"
                class="font-bold text-gray-450">{{ title }}</span>
        </div>
    </transition>
</template>

<script>
export default {
  name: 'ProductGalleryCaption',
  props: {
    preTitle: {
      type: String,
      required: false,
      default: '',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style scoped>

</style>
